"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateActiveFiltersFormCategoryAndType = exports.mergeContentFilterData = exports.normalizeContentFilter = void 0;
const common_types_1 = require("@as-react/common-types");
const normalizeContentFilter = (contentFilterValues, filterType, queryParamKey, nameTranslationKey, sortingType = 1, displayVariant, activeValues) => ({
    filterOn: contentFilterValues[0].value.split(':')[0],
    name: nameTranslationKey,
    type: filterType,
    values: contentFilterValues
        .map((filterValue) => {
        var _a;
        return ({
            name: filterValue.label,
            filterKey: (_a = filterValue.value.split(':')[1]) !== null && _a !== void 0 ? _a : '',
            itemCount: filterValue.count,
            active: !!activeValues && activeValues.length > 0 ? activeValues.indexOf(filterValue.value) !== -1 : false,
        });
    })
        .sort((a, b) => sortingType === common_types_1.ContentFilterSortingOption.ALPHABETICAL
        ? a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : -1
        : b.itemCount - a.itemCount),
    filterContentType: null,
    queryParamKey: queryParamKey,
    toggleFilterOptions: displayVariant === common_types_1.ContentFilterDisplayVariant.HIDE_EXTRA_ITEMS,
});
exports.normalizeContentFilter = normalizeContentFilter;
const mergeContentFilterData = (availableFilterValues, filterValues) => {
    return availableFilterValues
        .map((availableFilterValue) => {
        const filterValue = filterValues.find((filterValue) => filterValue.value === availableFilterValue.value);
        return filterValue
            ? Object.assign(Object.assign({}, filterValue), { count: availableFilterValue.count }) : null;
    })
        .filter((filterValue) => !!filterValue);
};
exports.mergeContentFilterData = mergeContentFilterData;
const getActiveFilterObj = (filters, filterKey, type) => {
    const filterOn = filterKey.split(':')[0];
    const activeFilter = filters.find((filter) => filter.filterOn === filterOn);
    return activeFilter
        ? {
            [filterOn]: {
                filterType: type,
                queryParamKey: activeFilter.queryParamKey,
                filterOnName: activeFilter.name,
                filterContentType: activeFilter.filterContentType,
                values: activeFilter.values
                    .filter((value) => value.active)
                    .map((value) => ({
                    filterKey: value.filterKey,
                    filterKeyName: value.name,
                })),
            },
        }
        : null;
};
const generateActiveFiltersFormCategoryAndType = (filters, category, type) => {
    const filterState = {};
    if (category) {
        filterState.activeFilters = Object.assign({}, getActiveFilterObj(filters, category, common_types_1.LINK_FILTER));
    }
    if (type && type.length > 0) {
        filterState.activeFilters = Object.assign(Object.assign({}, filterState.activeFilters), getActiveFilterObj(filters, type[0], common_types_1.MULTISELECT_FILTER));
    }
    return filterState;
};
exports.generateActiveFiltersFormCategoryAndType = generateActiveFiltersFormCategoryAndType;
//# sourceMappingURL=contentLister.util.js.map